{
  "browserNotSupported": {
    "title": "Δεν ήταν δυνατή η φόρτωση της μονάδας",
    "text": "Για να χρησιμοποιήσετε τη μηχανή αναζήτησης ανταλλακτικών, μεταβείτε σε ένα ενημερωμένο πρόγραμμα περιήγησης"
  },
  "main": {
    "more": "Περισσότερα αξεσουάρ",
    "findMore": "Μπορείτε να βρείτε αξεσουάρ για μετασκευή/μετατροπή και αναβάθμιση του οχήματός σας εδώ στην εκτεταμένη γκάμα μας. Τα αξεσουάρ που έχετε επιλέξει θα σταλούν στον συνεργάτη {{brand}} μαζί με το αίτημα του οχήματος.",
    "topOffers": "TOP Προσφορές",
    "article": "<0>{{min}} - {{max}} / </0>{{productCount}} Προϊόντα",
    "noArticleFound": "0 Προϊόντα",
    "oemHint": "Επιλέξτε ταιριαστά αξεσουάρ για το {{brand}} σας τώρα!",
    "noBrand": "Επιλέξτε ταιριαστά αξεσουάρ για το όχημά σας τώρα!",
    "outOfOrder": "Δυστυχώς δεν υπάρχουν διαθέσιμα προϊόντα αυτή τη στιγμή.<0/>Αυτή τη στιγμή ενημερώνουμε τον κατάλογό μας.<0/>Παρακαλούμε επισκεφθείτε μας ξανά σε μεταγενέστερη ημερομηνία.",
    "nextSlide": "Επόμενο",
    "prevSlide": "Προηγούμενο"
  },
  "cart": {
    "add": "Το προϊόν προστέθηκε στο όχημα",
    "fullPrice": "Τιμή οχήματος και αξεσουάρ",
    "priceWithoutCar": "Τιμή αξεσουάρ"
  },
  "navigation": {
    "zoom": "Μεγέθυνση",
    "toggleSearch": "Εναλλαγή αναζήτησης",
    "cart": "Καλάθι",
    "cartDelete": "Αφαίρεση προϊόντος από το καλάθι",
    "vehicle": "Επιλεγμένο όχημα",
    "maxBookmarksReached": "Μέγιστο όριο 15 προϊόντων",
    "filter": {
      "toggleFilter": "Εναλλαγή φίλτρου",
      "topProducts": "TOP Προσφορές",
      "reset": "Επαναφορά φίλτρου",
      "ready": "Τέλος",
      "show": "Εμφάνιση αποτελεσμάτων"
    },
    "searching": {
      "submit": "Υποβολή",
      "close": "Luk",
      "placeholder": "Βρείτε αντίστοιχα αξεσουάρ ...",
      "suggestions": "Προτάσεις αναζήτησης",
      "categories": "Κατηγορίες",
      "products": "Προϊόντα",
      "productCount": "{{count}} προϊόν",
      "productCount_other": "{{count}} προϊόντα",
      "showAll": "Εμφάνιση {{count}} αποτελέσματος",
      "showAll_other": "Εμφάνιση όλων των {{count}} αποτελεσμάτων",
      "expand": "Διευρυμένη αναζήτηση",
      "show": "Εμφάνιση αποτελεσμάτων",
      "found": {
        "withCategory": "Αποτελέσματα αναζήτησης για \"{{fuzzy}}\" στην κατηγορία \"{{category}}\"",
        "withOutCategory": "Αποτελέσματα αναζήτησης για \"{{fuzzy}}\" από όλες τις κατηγορίες"
      }
    },
    "share": "Κοινή χρήση",
    "back": "πίσω",
    "details": "λεπτομέρειες",
    "add": "Προσθήκη",
    "remove": "Αφαίρεση",
    "close": "Κλείσιμο",
    "filtern": "φίλτρο",
    "closeFilter": "Κλείσιμο φίλτρου"
  },
  "productDetail": {
    "gallery": {
      "jumpToImageNumber": "Μετάβαση στην εικόνα {{number}}"
    },
    "articleNumber": "Αριθμός προϊόντος",
    "relatedArticle": "Άλλα προϊόντα που μπορεί να σας ενδιαφέρουν:",
    "brand": "Μάρκα",
    "priceBox": {
      "withVatAndMounting": "συμπερ. του Φ.Π.Α. & της συναρμολόγησης",
      "withVat": "συμπερ. του Φ.Π.Α.",
      "recommendedRetailPrice": "Προτεινόμενη Λιανική Τιμή",
      "historicMinimalPurchasePrice": "Χαμηλότερη τιμή τις τελευταίες 30 ημέρες",
      "priceDetails": "Λεπτομέρειες τιμής",
      "priceDetailsHeadline": "Λεπτομέρειες τιμής για αυτό το προϊόν",
      "priceToday": "Τιμή για αυτό το προϊόν σήμερα",
      "priceDetails30Days": "Χαμηλότερη τιμή εντός 30 ημερών πριν από την αλλαγή της τιμής",
      "close": "Κλείσιμο παραθύρου",
      "addItem": "Προσθήκη προϊόντος",
      "removeItem": "Αφαίρεση προϊόντος"
    },
    "infoBox": {
      "description": "Περιγραφή",
      "vehicles": "Κατάλληλο για τα ακόλουθα μοντέλα",
      "empty": "Δεν υπάρχουν ειδικές αντιστοιχίσεις οχημάτων για αυτό το προϊόν.",
      "contacts": "Κατασκευαστής"
    },
    "contacts": {
      "manufacturer-contact": "Πληροφορίες επικοινωνίας κατασκευαστή",
      "responsible-contact": "Υπεύθυνο πρόσωπο εντός ΕΕ",
      "trademark": "Μάρκα"
    }
  },
  "productList": {
    "oemHint": "Γνήσια αξεσουάρ για το {{brand}} σας"
  }
}
